module.exports = __webpack_public_path__ + "static/media/phila_classic.146c8c2e.webp";